import type { Block, StreamingBlock, StreamingChatId } from "@storytell/streaming";
import { BaseBlockPreview } from "./internal/BaseBlockPreview";
import { createSignal, onCleanup, onMount } from "solid-js";
import { subscribeToBlockDeltas, subscribeToBlockStop } from "@storytell/streaming";

interface BlockPreviewProps {
  block: StreamingBlock;
  onClick: () => void;
}

export const BlockPreview = (props: BlockPreviewProps) => {
  const content = () => props.block.deltas.map((delta) => delta.text).join("");

  return (
    <div data-renderer="block-preview">
      <BaseBlockPreview block={props.block} onClick={props.onClick} variant="blue">
        <div class="w-full">
          <pre class="whitespace-pre-wrap text-sm font-mono">{content()}</pre>
        </div>
      </BaseBlockPreview>
    </div>
  );
};
